import { Button } from '@creditornot/cb-button';
import { cssThemedValue, typographyCss } from '@creditornot/cb-ingredients';
import { ModalContent, ModalFooter, ModalHeader } from '@creditornot/cb-modal';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { WoltModal } from 'common/components';

type Props = {
  open: boolean;
  loading: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

const Root = styled(WoltModal)`
  max-width: 400px;
`;

const Content = styled(ModalContent)`
  ${typographyCss.Body3}
  background-color: ${cssThemedValue('surfaceMain')};
`;

const Footer = styled(ModalFooter)`
  display: flex;
  justify-content: flex-end;
`;

const SubmitButton = styled(Button).attrs({ variant: 'blue', size: 'small' })`
  margin-inline-start: 16px;
`;

const CancelButton = styled(Button).attrs({ variant: 'lightBlue', size: 'small' })``;

const SubmitConfirmation = ({ open, onConfirm, onCancel, loading }: Props) => {
  return (
    <Root isOpen={open}>
      <ModalHeader>
        <FormattedMessage id="venue-data-collection.submit-confirmation.heading" />
      </ModalHeader>
      <Content>
        <FormattedMessage id="venue-data-collection.submit-confirmation.body" />
      </Content>
      <Footer>
        <CancelButton
          data-testid={'draft-venue-list-page-submit-confirmation-cancel-button'}
          disabled={loading}
          onClick={() => {
            onCancel();
          }}
        >
          <FormattedMessage id="venue-data-collection.submit-confirmation.cancel" />
        </CancelButton>
        <SubmitButton
          data-testid={'draft-venue-list-page-submit-confirmation-confirm-button'}
          loading={loading}
          onClick={() => {
            onConfirm();
          }}
        >
          <FormattedMessage id="venue-data-collection.submit-confirmation.submit" />
        </SubmitButton>
      </Footer>
    </Root>
  );
};

export default SubmitConfirmation;
